import { GET_CLIENTES, GET_CLIENTES_ID } from '../actions/actionClient';
import { POST_CLIENTES, PUT_CLIENTE } from '../actions/actionClient';
import { GET_SEARCH } from '../actions/actionClient';

const initialState = {
    allClientes: [],
    clientesDetail: [],
    postClientes: {},
    putClientes: {}
}

export default function reducerClient(state = initialState, action){
    switch (action.type) {        
        case GET_CLIENTES:
            return {
                ...state,
                allClientes: action.payload
            }
        case GET_CLIENTES_ID:
            return {
                ...state,
                clientesDetail: action.payload
            }
        case POST_CLIENTES:
            return {
                ...state,
                postClientes: action.payload
            }
        case PUT_CLIENTE:
            return {
                ...state,
                putClientes: action.payload
            }   
        case GET_SEARCH:
            return {
                ...state,
                allClientes: action.payload
            }                                                  
        default:
            return {...state};
    }
}